import { render, staticRenderFns } from "./PackageForm.vue?vue&type=template&id=4796bbb3&"
import script from "./PackageForm.vue?vue&type=script&lang=js&"
export * from "./PackageForm.vue?vue&type=script&lang=js&"
import style0 from "./PackageForm.vue?vue&type=style&index=0&id=4796bbb3&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports